import { z } from "zod/v4";

export const createMemberSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  email: z
    .email({ message: "Must be a valid email address" })
    .min(1, { message: "Email is required" }),
});

export type CreateMemberSchemaValues = z.infer<typeof createMemberSchema>;
